<template>
<div>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div slot="header" class="text-left" style="display: inline-flex;">
          <i class="nc-icon nc-mobile text-success" style="font-size: 35px;"></i>
          <h4 class="card-title" v-if="Object.keys(chartOptions5).length > 0">Total Llamadas Recibidas Ultimo Mes: {{(chartOptions5[0] ? formatMoney(chartOptions5[0].LlamadasRecibidas, 0) : 0)}}</h4>
        </div>
        <p class="card-category"><i class="fa fa-calendar-o"></i> Ultimo actualización {{currentTime}}</p>
      </card>
    </div>
  </div>
  <div class="row">
    <div class="col-xl-3 col-md-6">
      <stats-card v-if="Object.keys(chartOptions3).length > 0" v-bind:title="(chartOptions3[0] ? formatMoney(chartOptions3[0].umbral30s, 0) : 0) + ''" subTitle="Umbral<30s Si Ultimo Mes">
        <div slot="header" class="icon-success">
          <i class="nc-icon nc-mobile text-success"></i>
        </div>
        <template slot="footer">
          <i class="fa fa-calendar-o"></i> Ultimo actualización {{currentTime}}
        </template>
      </stats-card>
    </div>
    <div class="col-xl-3 col-md-6">
      <stats-card v-if="Object.keys(chartOptions3).length > 0" v-bind:title="(chartOptions3[1] ? formatMoney(chartOptions3[1].umbral30s, 0) : 0) + ''" subTitle="Umbral<30s No Ultimo Mes">
        <div slot="header" class="icon-danger">
          <i class="nc-icon nc-mobile text-danger"></i>
        </div>
        <template slot="footer">
          <i class="fa fa-calendar-o"></i> Ultimo actualización {{currentTime}}
        </template>
      </stats-card>
    </div>
    <div class="col-xl-3 col-md-6">
      <stats-card v-if="Object.keys(chartOptions4).length > 0" v-bind:title="(chartOptions4[0] ? formatMoney(chartOptions4[0].LlamadasRecibidas, 0) : 0) + ''" subTitle="Llamadas Recibidas Success">
        <div slot="header" class="icon-success">
          <i class="nc-icon nc-mobile text-success"></i>
        </div>
        <template slot="footer">
          <i class="fa fa-refresh"></i> Ultimo actualización {{currentTime}}
        </template>
      </stats-card>
    </div>
    <div class="col-xl-3 col-md-6">
      <stats-card v-if="Object.keys(chartOptions4).length > 0" v-bind:title="(chartOptions4[1] ? formatMoney(chartOptions4[1].LlamadasRecibidas, 0) : 0) + ''" subTitle="Llamadas Recibidas Abandonado">
        <div slot="header" class="icon-danger">
          <i class="nc-icon nc-mobile text-danger"></i>
        </div>
        <template slot="footer">
          <i class="fa fa-refresh"></i> Ultimo actualización {{currentTime}}
        </template>
      </stats-card>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div v-if="canIndex()" class="text item">
          <div class="col-12">
            <div class="row">
              <div class="col-6 col-sm-4 col-md-2">
                <el-select
                  class="select-default mb-3"
                  v-model="pagination.perPage"
                  placeholder="Por pagina">
                  <el-option
                  class="select-default"
                  v-for="item in pagination.perPageOptions"
                  :key="item"
                  :label="item"
                  :value="item">
                  </el-option>
                </el-select>
              </div>
              <div class="col-6 col-sm-4 col-md-5">
                <el-date-picker
                  class="picker-filter"
                  style="width: 100%"
                  :clearable="false"
                  v-model="rangeDate"
                  type="daterange"
                  @change="getDataByProyectDates"
                  :picker-options="pickerOptions"
                  range-separator="-"
                  start-placeholder="Fecha Inicial"
                  end-placeholder="Fecha Final"
                  align="center">
                </el-date-picker>
              </div>
              <div class="col-6 col-sm-4 col-md-3" style="width: 100%">
                <div class="mr-1 pull-right" v-if="canPDF()">
                  <img
                    class="img-exports"
                    src="/static/img/icons/docs/pdf.svg"
                    alt="pdf"
                    v-tooltip="'Exportar en formato PDF'"
                    @click="exportPDF('canal_atencion_telefonica', 'Canal de atención telefonica', 'a4', tableData, tableColumns)">
                </div>
                <div class="mr-1 pull-right" v-if="canExcel()">
                    <img
                      class="img-exports"
                      src="/static/img/icons/docs/xls.svg"
                      alt="xls"
                      v-tooltip="'Exportar en formato XLSX'"
                      @click="exportExcel('canal_atencion_telefonica', tableData, tableColumns)">
                </div>
                <div class="mr-1 pull-right" v-if="canCSV()">
                  <img
                    class="img-exports"
                    src="/static/img/icons/docs/csv.svg"
                    alt="csv"
                    v-tooltip="'Exportar en formato CSV'"
                    @click="exportCSV('canal_atencion_telefonica', tableData, tableColumns)">
                </div>
              </div>
              <div class="col-6 col-sm-4 col-md-2">
                <br class="c-none">
                <el-input
                class="mb-3"
                placeholder="Buscar registros"
                v-model="searchQuery"
                aria-controls="datatables"/>
              </div>
            </div>
          </div>
          <div class="col-sm-12">
            <el-table
                      style="width: 100%;"
                      :data="queriedData"
                      border>
              <el-table-column v-for="column in tableColumns"
                               :key="column.label"
                               :min-width="column.minWidth"
                               :prop="column.prop"
                               :label="column.label">
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <div class="text-center">
            <h4> <strong> No tienes permiso para indexar información </strong></h4>
          </div>
        </div>
        <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
          <div class="">
            <p class="card-category">Mostrando {{from + 1}} a {{to}} de {{total}} entradas</p>
          </div>
          <l-pagination class="pagination-no-border"
                        v-model="pagination.currentPage"
                        :per-page="pagination.perPage"
                        :total="pagination.total">
          </l-pagination>
        </div>
      </card>
      <div class="row">
        <div class="col-4">
          <div class="text-right">
            <button class="btn btn-danger btn-fg custom-shadow-btn" @click="exportPDF('canal_atencion_telefonica', 'Canal de atención telefonica', 'a4', tableData, tableColumns)"><i class="fa fa-file-pdf-o"></i>
                Exportar a PDF
            </button>
          </div>
        </div>
        <div class="col-4">
          <div class="text-center">
            <button oncli class="btn btn-success btn-fg custom-shadow-btn" @click="exportExcel('canal_atencion_telefonica', tableData, tableColumns)"><i class="fa fa-file-excel-o"></i>
            Exportar a Excel
          </button>
          </div>
        </div>
        <div class="col-4">
          <div class="text-left">
            <button class="btn btn-info btn-fg custom-shadow-btn" @click="exportCSV('canal_atencion_telefonica', tableData, tableColumns)"><i class="fa fa-file-text-o"></i>
              Exportar a CSV
            </button>
          </div>
        </div>
      </div>
      <br/>
    </div>
  </div>
</div>
</template>
<script>
  import mixinMasters from 'src/util/mixinMasters'
  import mixinPermissions from 'src/util/mixinPermissions'
  import MixinDatePicker from "src/util/mixinDatePicker"
  import mixinCharts from "src/util/mixinCharts"
  import table from './telephoneAttentionChannelTable'
  import moment from 'moment'
  import {StatsCard} from 'src/components/index'

  export default {
    components: {
      /* Checkbox,
      Card,
      LTable,
      ChartCard, */
      StatsCard,
    },
    data () {
      return {
        currentTime: moment().format('hh:mm:ss'),
        monitorings: null,
        tableColumns: table,
        isShow: true,
        rangeDate: [new Date(new Date().getFullYear(), 0, 1), new Date()],
        init_date: moment(new Date(new Date().setDate(new Date().getDate() - new Date().getDay()))).format('YYYY-MM-DD'),
        end_date: moment(new Date(new Date().setDate(new Date().getDate() - new Date().getDay()+2))).format('YYYY-MM-DD'),
        chartOptions1: {},
        chartOptions2: {},
        chartOptions3: {},
        chartOptions4: {},
        chartOptions5: {},
      }
    },
    mixins: [mixinMasters, mixinPermissions, MixinDatePicker, mixinCharts],
    methods: {
      getDataByProyectDates() {
        let self = this
        this.$emit('cotentLoading', true)

        let data = {}
        data.route ='telephoneattentionchannel'
        data.init_date = moment(this.rangeDate[0]).format('YYYY-MM-DD')
        data.end_date = moment(this.rangeDate[1]).format('YYYY-MM-DD')
        let data1 = {}
        data1.route ='qualityusersupports/dashboard'
        data1.init_date = this.init_date
        data1.end_date = this.end_date

        self.saveMaster(data).then((response) => {
          self.saveMaster(data1).then((response1) => {
            self.chartOptions3 = response1.data.chart3
            self.chartOptions4 = response1.data.chart4
            self.chartOptions5 = response1.data.chart5
            self.tableData = response.data
            self.searchFuse(table.map(prop => { return prop.prop }))
            self.$emit('cotentLoading', false)
          })
        }).catch((error) => {
          self.showMessageErrors(error)
          self.$emit('cotentLoading', false)
        })
      },
    },
    created(){
      if(this.canIndex()) {
        this.getDataByProyectDates()
      }
    }
  }
</script>
